module.exports = __webpack_public_path__ + "img/banner-img.43cf9ae0.png";